import React, { useState, useEffect, useCallback } from 'react';
import { QrReader } from 'react-qr-reader';
import { useDispatch} from 'react-redux';
import { injectIntl } from 'react-intl';
import translate from '../../i18n/translate';

import { actions } from '../../actions/actions';
import QrCodeTarget from '../../components/svgs/QrCodeTarget';
import Footer from '../../components/Footer/Footer';
import { QrCodeStyle } from './qrcodeStyle';

const MUSEU_HOST = /(^|\.)museulight\.com\.br$/;

export const toSafeUrl = text => {
  try {
    const bruto = String(text).trim();
    const url = new URL(bruto, bruto.startsWith('?') ? window.location.origin : undefined);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    const mesmaOrigem = url.origin === window.location.origin;
    return mesmaOrigem || MUSEU_HOST.test(url.hostname) ? url.href : null;
  } catch (e) {
    return null;
  }
};

const QrCode = ({ intl }) => {
  const dispatch = useDispatch();
  const setOriginRoute = useCallback(routeChoice => dispatch(
    actions.setOriginRoute(routeChoice)
  ), [dispatch]);

  // const [code, setCode] = useState('');
  // const [result, setResult] = useState('');
  const [webcamEnabled, setWebcamEnabled] = useState(true);
  const [codeNotFound, setCodeNotFound] = useState(false);
  // const dataAudioguide = useSelector(state => state.audioGuideReducers.dataAudioguide);

  useEffect(() => { setOriginRoute('code') }, [setOriginRoute])

  // O texto do QR code vem de fora do app. Só segue links http(s) do próprio app
  // ou de museulight.com.br; qualquer outra coisa (javascript:, data:, site de
  // terceiros) cai na mensagem de código não encontrado.
  const openQrCodeLink = data => {
    const target = toSafeUrl(data.text);
    if (!target) {
      setCodeNotFound(true);
      return;
    }
    window.location.assign(target);
  }

  const onClickAllowWebcan = () => {
    alert("abriu camera")
    navigator.getUserMedia(
      // constraints
      {
        video: true,
        audio: true
      },

      // successCallback
      function (localMediaStream) {
        //user allowedpdate the permission setting
        setWebcamEnabled(true);
      },

      // errorCallback
      function (err) {
        // Explain why you need permission and how to update the permission setting
        alert('Para usar o leitor de QRCode é necessário permitir o acesso à camera.');
      }
    );
  }

  return (
    <QrCodeStyle>
      <p className={`code-instruction${codeNotFound ? ' code-not-found' : ''}`}>
        {
          codeNotFound ? translate('msgQRCodeError') : translate('msgQRCode')
        }
      </p>
      <div className="qr-code-wrapper">
        {webcamEnabled
          ? (
            <QrReader
              constraints={{
                facingMode: 'environment'
              }}
              scanDelay={300}
              onResult={(result, error) => {
                if (!!result) {
                  openQrCodeLink(result);
                }
                if (!!error) {
                  if (error.name === "NotAllowedError") {
                    setWebcamEnabled(false);
                  }
                }
              }}
            />
          ) : null
        }
        <div className="code-target">
          <QrCodeTarget allowed={webcamEnabled} />
          {!webcamEnabled
            ? (
              <button
                type="button"
                className="allow-webcan"
                onClick={onClickAllowWebcan}
              >
                {translate('allowCam')}
              </button>
            ) : null
          }
        </div>
      </div>
      <Footer />
    </QrCodeStyle>
  );
};
export default injectIntl(QrCode);